import { FC, PropsWithChildren } from 'react';
import { Grid } from '@wegroup/design-system';

interface Props {
  singleColumn?: boolean;
}

const ConfigureItemsGrid: FC<PropsWithChildren<Props>> = ({
  children,
  singleColumn,
}) => {
  return (
    <Grid
      templateColumns={
        singleColumn ? '1fr' : 'repeat(auto-fill, minmax(288px, 1fr))'
      }
      gap={4}
    >
      {children}
    </Grid>
  );
};

export default ConfigureItemsGrid;
